import { useEffect, ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import useFetchFedwireWithdrawTransaction from '@/hooks/useApi/useFetchFedwireWithdrawTransaction';
import FedwireWithdrawalTransactionInfo from './FedwireWithdrawalTransactionInfo';
import { useUserSettingsProvider } from '@/providers/UserSettings.provider';
import { useBlockingLoader } from 'shared';
import { useAlertDialog } from '@/providers/AlertDialog.provider';

type FedwireWithdrawalContainerProps = {
  TransactionID: string;
} & Omit<ComponentProps<typeof FedwireWithdrawalTransactionInfo>, 'transaction'>;

export default function FedwireWithdrawalContainer({
  TransactionID,
  Notes,
  jwt,
  ELinxRequestID = '',
  ...props
}: FedwireWithdrawalContainerProps) {
  const { userSettings } = useUserSettingsProvider();
  const blockingLoader = useBlockingLoader();
  const alertDialog = useAlertDialog();
  const { t: tGlobal } = useTranslation('translations', { keyPrefix: 'Global' });

  const { fedwireWithdrawTransaction, fetchFedwireWithdrawTransaction } = useFetchFedwireWithdrawTransaction({
    bearer: jwt,
  });

  useEffect(() => {
    blockingLoader.show();

    fetchFedwireWithdrawTransaction({ TransactionID, Timezone: userSettings.timezone })
      .catch((error) =>
        alertDialog.error(tGlobal('error'), error instanceof Error ? error.message : tGlobal('errorOccurred')),
      )
      .finally(() => blockingLoader.hide());
  }, [TransactionID]);

  const transaction = fedwireWithdrawTransaction;

  return (
    <div>
      {transaction && (
        <FedwireWithdrawalTransactionInfo
          transaction={transaction}
          Notes={Notes}
          jwt={jwt}
          ELinxRequestID={ELinxRequestID}
          {...props}
        />
      )}
    </div>
  );
}
